<template>
  <div class="page-content">
    <el-row  class="product-menu" type="flex">
      <el-col>
         <el-button type="primary" class="first-btn" @click="addModel">添加模块</el-button>
      </el-col>
      <el-col :span="6" style="margin-right:20px">
        <el-input placeholder="请输入菜单名称" v-model.trim="menuName" class="input-with-select" >
          <el-button slot="append" icon="el-icon-search" @click="sel"></el-button>
        </el-input>
      </el-col>
      <el-col :span="6">
        <el-input placeholder="请输入菜单路径" v-model.trim="menuUrl" class="input-with-select" >
          <el-button slot="append" icon="el-icon-search" @click="selUrl"></el-button>
        </el-input>
      </el-col>
    </el-row>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="cellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <!-- <el-table-column
         prop="menuId"
          label="菜单id">
        </el-table-column> -->
        <el-table-column
         prop="menuName"
          label="菜单名称">
        </el-table-column>
        <el-table-column
         prop="menuUrl"
          label="菜单路径">
        </el-table-column>
        <el-table-column
         prop="menuIcon"
          label="菜单图标">
          <template slot-scope="scope">
            <el-col :class="scope.row.menuIcon"></el-col>
          </template>
        </el-table-column>
        <el-table-column
         prop="createUser"
          label="创建者">
        </el-table-column>
        <el-table-column
         prop="createTime"
          label="创建时间">
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <div class="opreationBtn">
              <span class="check" @click="handlerClick('check',scope.row)">查看</span>
              <span class="edit" @click="handlerClick('edit',scope.row)">编辑</span>
              <span class="assign" @click="handlerClick('assign',scope.row)">绑定按钮</span>
              <span class="del" @click="handlerClick('del',scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页管理 -->
    <paging :total="total" @changePage="changePage"/>
    <!-- 新增用户dialog -->
    <addDialog v-if="addDialogVisible" :addDialogVisible="addDialogVisible" @closeAddDialog="closeAddDialog"/>
    <!-- 查看/编辑用户dialog -->
    <editDialog v-if="editDialogVisible" :editDialogVisible="editDialogVisible" :editData="editData" @closeEditDialog="closeEditDialog" :status="status"/>
    <!-- 分配用户dialog -->
    <assignDialog v-if="assignDialogVisible" :assignDialogVisible="assignDialogVisible" :menuId="menuId" @closeAssignDialog="closeAssignDialog"/>
  </div>
</template>

<script>
import addDialog from '@/components/modelManager/addMenuDialog'
import editDialog from '@/components/modelManager/editMenuDialog'
import assignDialog from '@/components/modelManager/assignMenuDialog'
import { list, deleteMenu } from '@/api/modelManager'
import { eventBus } from '@/utils/eventBus'
import paging from '@/components/paging'
export default {
  data () {
    return {
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      // ------------
      tableData: [],
      // checked: false,
      // 设置表格的样式
      cellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      addDialogVisible: false,
      // viewDialogVisible: false,
      // viewData: null,
      editDialogVisible: false, // 编辑或者查看
      editData: null,
      status: false,
      menuId: '',
      assignDialogVisible: false,
      menuName: '',
      menuUrl: ''
    }
  },
  components: {
    addDialog,
    editDialog,
    assignDialog,
    paging
  },
  created () {
    this.getMenuList()
  },
  methods: {
    // 搜索功能
    sel () {
      this.listQuery.page = 1
      this.getMenuList()
    },
    selUrl () {
      this.listQuery.page = 1
      this.getMenuList()
    },
    getMenuList () {
      const params = {
        menuName: this.menuName,
        menuUrl: this.menuUrl,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      list(params).then((res) => {
        const resData = res.data.data
        this.total = resData.total
        this.tableData = resData.list
        this.tableData.forEach((ele) => {
          if (ele.menuType === 1) {
            ele.menuType = '菜单/页面'
          } else {
            ele.menuType = '标签/按钮'
          }
          if (ele.menuUrl === '' || JSON.stringify(ele.menuUrl) === 'null') ele.menuUrl = '---'
          if (ele.menuIcon === '' || JSON.stringify(ele.menuIcon) === 'null') ele.menuIcon = '---'
        })
      })
    },
    addModel () {
      this.addDialogVisible = true
    },
    closeAssignDialog (val) {
      this.assignDialogVisible = false
      if (val) {
        this.getMenuList()
      }
    },
    closeAddDialog (val) {
      this.addDialogVisible = false
      if (val) {
        this.getMenuList()
      }
    },
    closeEditDialog (val) {
      this.editDialogVisible = false
      if (val) {
        this.getMenuList()
      }
    },
    handlerClick (sty, row) {
      switch (sty) {
        case 'check':
          this.editDialogVisible = true
          this.status = true
          this.editData = Object.assign({}, row)
          break
        case 'edit':
          this.editDialogVisible = true
          this.status = false
          this.editData = Object.assign({}, row)
          break
        case 'assign':
          console.log('分配权限')
          this.menuId = row.menuId
          this.assignDialogVisible = true
          break
        case 'del':
          this.$confirm('确定删除此记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const id = row.menuId
            deleteMenu(id).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getMenuList()
                eventBus.$emit('updataMentList')// 更新左侧菜单
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '删除取消'
            })
          })
          break
        default:
          break
      }
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.menuUrl = ''
      this.getMenuList()
    }
  }
}
</script>

<style lang="less" scoped>
  .page-content{
     .tap-title{
      margin-bottom: 30px;
      padding-left: 10px;
      display: flex;
      border-left: 5px solid skyblue ;
      font-size: 16px;
    }
    .product-menu{
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .showOnline{
        margin-right: 20px;
      }
      .is-justify-end{
        align-items: center;
      }
      .left{
        span{
          margin-right: 20px;
          font-size: 20px;
          font-weight: 600;
        }
        .first-btn{
          margin-right: 10px;
        }
        .refalsh{
          margin-right: 20px;
        }
      }

    }

    .dataList{
      background-color: white;
      margin-bottom: 20px;
      .cell{
        text-align: center;
      }
      .opreationBtn{
        .check,.edit, .assign{
          color: #35a6df;
          cursor: pointer;
        }
        .del,.stop{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .onlineStatus{
        .online{
          color: #138c4b;
        }
        .offline{
          color: red
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
